import { memo, useMemo, useState } from 'react';
import { asString } from './helpers';

const InvestorShortInfo = memo(function InvestorShortInfo({
  shortInfo,
  t,
  maxLength = 100,
  className = 'text-xs text-stone-700',
  buttonClassName = 'ml-4 inline-flex cursor-pointer items-center gap-1 text-xs text-blue-600 hover:text-blue-800 bg-blue-50 hover:bg-blue-100 px-2 py-1 rounded-full',
}) {
  const [open, setOpen] = useState(false);
  const text = useMemo(() => asString(shortInfo).trim(), [shortInfo]);

  if (!text) {
    return null;
  }

  const isLong = text.length > maxLength;
  const visibleText = open || !isLong ? text : `${text.slice(0, maxLength)}...`;

  return (
    <div className={className}>
      <span>{visibleText}</span>
      {isLong && (
        <button
          type="button"
          onClick={() => setOpen((value) => !value)}
          className={buttonClassName}
        >
          {open ? t('investorCard.showLess') : t('investorCard.readMore')}
        </button>
      )}
    </div>
  );
});

export default InvestorShortInfo;
